module.exports = {"513430100":"天地坝镇","513430101":"派来镇","513430102":"芦稿镇","513430103":"对坪镇","513430104":"南瓦镇","513430105":"百草坡镇","513430106":"洛觉镇","513430107":"德溪镇","513430108":"丙底镇","513430201":"热水河乡","513430206":"甲依乡","513430210":"基觉乡","513430211":"小银木乡","513430214":"青松乡","513430217":"山江乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513430.json
// module id = 2571
// module chunks = 0